<div class="dialog-content-wrapper no-overflow">
    <div class="dialog-content h-100-p w-100-p" fxLayout="column" fxLayoutAlign="start stretch">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="dialog-title">
            <span *ngIf="!task.id" class="title dialog-title">Add Task</span>
            <span *ngIf="task.id && (task.taskStatus < 30) && (!readOnly)" class="title dialog-title">Edit Task</span>
            <span *ngIf="task.id && ((task.taskStatus >= 30) || (readOnly))" class="title dialog-title">View Task</span>
            <div class="actions" fxLayout="row" fxLayoutAlign="start center">
                <mat-divider class='style-fix' [vertical]="true"></mat-divider>
                <button mat-icon-button class="mat-icon-button dialog-title" (click)="toggleStar($event)" aria-label="Toggle star" matTooltip="Toggle the Starred flag" [disabled]='((task.taskStatus >= 30) || task?.readOnly || readOnly)'>
                        <mat-icon class='star' *ngIf="task.starred">star</mat-icon>
                        <mat-icon class='fg-icon' *ngIf="!task.starred">star_outline</mat-icon>
                    </button>
                <button mat-icon-button class="mat-icon-button dialog-title" (click)="toggleImportant($event)" aria-label="Toggle important" matTooltip="Toggle the Important flag" [disabled]='((task.taskStatus >= 30) || task?.readOnly || readOnly)'>
                        <mat-icon class='important' *ngIf="task.important">error</mat-icon>
                        <mat-icon class='fg-icon' *ngIf="!task.important">error_outline</mat-icon>
                    </button>

                <mat-divider class='style-fix' [vertical]="true"></mat-divider>

                <button mat-icon-button class="mat-icon-button dialog-title" (click)="closeDialog();" aria-label="Close dialog">
                        <mat-icon class='fg-icon'>close</mat-icon>
                    </button>
            </div>
        </div>
    </mat-toolbar>
    <fuse-task-details class="task-details" #details [allowEdit]='!readOnly' [task]='task' [dialogRef]='dialogRef' [inWidget]='inWidget' [showLink]='showLink' [setFocus]="true">
    </fuse-task-details>
</div>
</div>